export const webClientId = '393733758580-dnanp1oc0gkv3k4jqcg0di4fev8ediap.apps.googleusercontent.com'